import React, { useContext } from "react"

export const GuideContext = React.createContext()

export const useGuide = () => {
    return useContext( GuideContext )
}